export interface Menu {
    id: number;
    visible: boolean;
    categoria: string;
    categoriaDetalle: string;
    alias: string;
    dependencias: entities[];
    recursos: Recursos[];
}

interface Recursos {
    id: number;
    visible: boolean;
    nombreRecurso: string;
    dependencias: entities[];
    subMenu?: boolean;
    url: string;
    alias: string;
    recursos?: any[];
}

export enum entities {
    portalGovCo,
    sedesElectronicas,
    tramitesServicios,
    ventanillasUnicas,
    portalesTransversales,
}